import { signOut } from 'aws-amplify/auth'

import { getEnv } from '@/config/env'
import { appUrl } from '@/config/paths'
import { assignLocation } from '@/lib/browser/navigate'
import { queryClient } from '@/lib/query/query-client'

import { clearLastActivity } from './idle-store'
import { purgeResidualTokens } from './token-storage'

const LOGIN_URL = appUrl('/login?error=session-expired')

let inFlight = false

export async function endSession(): Promise<void> {
  if (inFlight) return
  inFlight = true

  clearLastActivity()

  try {
    await signOut()
  } catch {}

  purgeResidualTokens(getEnv().VITE_COGNITO_CLIENT_ID)
  queryClient.clear()
  assignLocation(LOGIN_URL)
}
